import { g as n } from "../../utils-BOfnFgIH.js";
import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as o, normalizeClass as s, createElementVNode as a } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const m = {
  name: "DtIconThermometerSun",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = n();
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], f = ["clip-path"], p = ["id"];
function h(e, t, l, _, v, i) {
  return d(), o("svg", {
    "aria-label": l.ariaLabel,
    class: s([i.iconSizeClass, "d-icon d-icon--thermometer-sun"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Thermometer Sun",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, [...t[0] || (t[0] = [
      a("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M4.46 4.505A2.5 2.5 0 0 1 6.009 4a.5.5 0 0 1-.016 1 1.5 1.5 0 0 0-.75 2.812.5.5 0 1 1-.484.876 2.5 2.5 0 0 1-.297-4.183ZM6 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0v-1A.5.5 0 0 1 6 1ZM3.654 8.846a.5.5 0 0 1 0 .708l-.7.7a.5.5 0 0 1-.708-.708l.7-.7a.5.5 0 0 1 .708 0ZM9 1.5a.5.5 0 0 0-.5.5v5.27a.5.5 0 0 1-.25.433 1.5 1.5 0 1 0 1.5 0 .5.5 0 0 1-.25-.433V2a.5.5 0 0 0-.5-.5ZM7.94.94A1.5 1.5 0 0 1 10.5 2v5.002a2.5 2.5 0 1 1-3 0V2c0-.398.158-.78.44-1.06ZM.5 6.5A.5.5 0 0 1 1 6h1a.5.5 0 0 1 0 1H1a.5.5 0 0 1-.5-.5Zm1.611-3.889a.5.5 0 0 1 .708 0l.705.705a.5.5 0 1 1-.708.708l-.705-.705a.5.5 0 0 1 0-.708Z",
        "clip-rule": "evenodd"
      }, null, -1)
    ])], 8, f),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...t[1] || (t[1] = [
        a("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, p)
    ])
  ], 10, c);
}
const Z = /* @__PURE__ */ u(m, [["render", h]]);
export {
  Z as default
};
//# sourceMappingURL=thermometer-sun.js.map
